"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapArrayToMediaHelper = void 0;
var styled_components_1 = require("styled-components");
var mapViewportSizeToPx_1 = __importDefault(require("../../helperFunctions/mapViewportSizeToPx"));
var mapArrayToMediaHelper = function (array, contentFn, cssKey) {
    return array.map(function (obj) { return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (min-width: ", "px) {\n        ", ";\n      }\n    "], ["\n      @media (min-width: ", "px) {\n        ", ";\n      }\n    "])), mapViewportSizeToPx_1.default(obj.size), contentFn(obj[cssKey])); });
};
exports.mapArrayToMediaHelper = mapArrayToMediaHelper;
var templateObject_1;
//# sourceMappingURL=alignment.js.map